import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";

interface FormFields {
  code: string;
  token: string;
}

export const apiSignIn = async (values: {
  password: string;
  email: string;
}) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });

  try {
    const uri = `/auth/login/user`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    // Send the POST request to log in
    const result = await Axios.post(uri, formData, cfg);
    const result_token = result?.data?.data?.accessToken;
    const token_refresh = result?.data?.data?.refreshToken;

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response if the login fails
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiVerifyEmail = async (value: { email: string }) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/auth/verify-account/`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    formData.append("email", value?.email);
    return await Axios.post(uri, formData.toString(), cfg);
  } catch (e: any) {
    console.error(e);
    return { status: "error", msg: e?.response?.data?.message || e?.message };
  }
};

export const apiVerifyAccount = async (formFields: FormFields) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(formFields).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/auth/verify-account/`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.patch(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      status: "error",
      msg: e?.response?.data?.message || e?.message || "An error occured",
    };
  }
};

interface FacilityFields {
  email: string;
  facility_size: string;
  name: string;
  password: string;
  facility_type: string;
}

interface UpdateFacility {
  facility_id?: string;
  address: string;
  city: string;
  contact_email: string;
  contact_job_title: string;
  contact_name: string;
  email?: string;
  facility_size?: string;
  name?: string;
  password?: string;
  phone_number: string;
  reg_no: string;
  other_registration_number?: string;
  specialties: string[];
  state: string;
  facility_type?: string;
  locationDetails?: {
    address: string;
    latitude: number;
    longitude: number;
    city?: string;
    state?: string;
    country?: string;
  };
}

export const apiSignUpFacility = async (formFields: FacilityFields) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(formFields).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/auth/signup/facility/`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      status: "error",
      msg: e?.response?.data?.message || e?.message || "An error occured",
    };
  }
};

export const apiUpdateSignUpFacility = async (formFields: UpdateFacility) => {
  console.log(formFields);
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(formFields).forEach(([key, value]) => {
    if (value !== undefined) {
      if (typeof value === "object") {
        formData.append(key, JSON.stringify(value)); // ✅ serialize nested object
      } else {
        formData.append(key, value.toString());
      }
    }
  });
  try {
    const uri = `/auth/verify/facility/`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      status: "error",
      msg: e?.response?.data?.message || e?.message || "An error occured",
    };
  }
};

export const apiForgotPasswordEmail = async (value: { email: string }) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/auth/forgot-password`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    formData.append("email", value?.email);
    return await Axios.post(uri, formData.toString(), cfg);
  } catch (e: any) {
    console.error(e);
    return { status: "error", msg: e?.response?.data?.message || e?.message };
  }
};

interface ApiResetPasswordPropsTypes {
  email: string;
  otp: string;
  password: string;
  token: string;
}

export const apiResetPassword = async (
  formFields: ApiResetPasswordPropsTypes,
) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(formFields).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/auth/reset-password`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return { status: "error", msg: e?.response?.data?.message || e?.message };
  }
};
